import React, { Component } from 'react';
import { Cascader } from '@tinper/next-ui'
import './GroupCascader.less'

class GroupCascader extends Component {
  constructor (props: {}) {
    super(props)
    this.state = {
      allTabsData: [{ key: '1' }],
      linkKey: '',
      tabsActiveKey: '1',
      searchValue: [], // 懒加载搜索时存储的结果
      dropdownRender: null,
      inputValue: ''
      // options: props.options
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps: any) {
    if ('searchValue' in nextProps && JSON.stringify(this.props.searchValue) !== JSON.stringify(nextProps.searchValue)) {
      this.setState({
        searchValue: nextProps.searchValue
      }, () => {
        console.log('UNSAFE_componentWillReceiveProps', nextProps.searchValue)
        this.changeSearchDom(nextProps.searchValue)
      })
      // this.changeSearchDom(nextProps.searchValue)
    }
  }

  renderDropdown = (val: any) => { // 加载搜索项
    return (<div className="ac-group-cascader-dropdown-search-box">
      {val.map((item: any, index: number) => {
        return <div key={index} className="ac-group-cascader-dropdown-search-item" onClick={this.changeSearchItem.bind(this, item)}>{item.name}</div>
      })}
    </div>)
  }

  changeSearchItem = (val: any) => { // 选择搜索项
    // let path = val?.path
    // let optionsPath = this.addChildren(path)
    this.setState({
      dropdownRender: null
    })
    this.cascader1.searchTiledItem(val)
  }

  // addChildren = (arr) => {
  //   let newArr = arr.map(item => {
  //     return {...item, children: []}
  //   })
  //   console.log('==========', newArr)
  //   let newArr1 = [...newArr]
  //   for (let i = newArr1?.length; i > 0 ; i--) {
  //     // newArr[i - 1].children = newArr[i]
  //     // if (newArr[i - 1].children) {
  //     //   newArr[i - 1].children.push(arr[i])
  //     // } else {
  //     //   newArr[i - 1].children = arr[i]
  //     // }
  //     if (i == 0) {
  //       // newArr[0].children = newArr[0]
  //     } else {
  //       // newArr[i - 1].children = arr[i]
  //     }
  //     newArr1[i - 1].children.push(newArr1[i])
  //     // newArr1[i - 1].children = [...newArr1[i]] || []
  //   }
  //   delete newArr1[newArr1.length - 1].children
  //   console.log('最后的新数组', newArr1)
  //   let optionsCopy = [...this.state.options]
  //   this.setState({
  //     options: [...optionsCopy, {...newArr1[0]}]
  //   })
  // }

  changeSearchDom = (val: any) => {
    if (val?.length === 0) {
      this.setState({
        dropdownRender: null
      })
    } else {
      this.setState({
        dropdownRender: this.renderDropdown.bind(this, val)
      })
    }
  }

  onChangeWz = (val: any) => {
    const { tabsActiveKey, allTabsData } = this.state
    const { fieldNames } = this.props
    const valueKey = fieldNames?.value || 'value'
    this.setState({
      linkKey: val.key
    })
    allTabsData.forEach((item: any) => {
      if (tabsActiveKey === item.key) {
        item.linkKey = val.key
      }
    })
    // console.log('^&^&^&^&', allTabsData)

    const targetEle = document.getElementById(`${val.data[0][valueKey]}`)
    const parentElement: any = targetEle?.parentNode
    parentElement!.scrollTop = targetEle!.offsetTop - 50
    // targetEle?.scrollIntoView(true)
  }

  onChangeTabs = (val: any) => {
    const { allTabsData } = this.state
    // console.log('页签切换', allTabsData, val)
    const newAllTabsData = [...allTabsData]
    let linkKey = ''
    newAllTabsData.forEach(item => {
      if (val === item.key) {
        linkKey = item.linkKey
      }
    })
    this.setState({
      linkKey,
      tabsActiveKey: val
    })
  }

  onChangeValue = (val: any) => {
    const { fieldNames } = this.props
    const valueKey = fieldNames?.value || 'value'
    // const labelKey = fieldNames?.label || 'label'
    this.cascader1.onChangeValue(val)
    // this.getContentData(val, )
    // this.dropdownTabsContent()
    const { allTabsData } = this.state
    const newAllTabsData = [...allTabsData]
    newAllTabsData.push({ key: val[valueKey], linkKey: val.groupTopKey })
    this.setState({
      linkKey: '',
      allTabsData: newAllTabsData,
      tabsActiveKey: val[valueKey]
    })
  }

  getContentData = (val: any) => {
    // let { linkKey, allData } = this.state
    const newArr: any[] = []
    val?.forEach((item: any) => {
      newArr.push(item.groupContentKey)
    })
    const newList1 = Array.from(new Set(newArr))
    const changeDataArr: any[] = []
    newList1.forEach(item => {
      const newObj: any = { data: [] }
      val?.forEach((label: any) => {
        if (item === label.groupContentKey) {
          newObj.groupContentKey = item
          newObj.data.push(label)
        }
      })
      changeDataArr.push(newObj)
    })
    return changeDataArr
  }

  getTopLink = (val: any) => {
    const newArr: any = []
    if (val && val?.length > 0) {
      val.forEach((item: any) => {
        newArr.push({ key: item.groupTopKey, data: item })
      })
    }
    if (newArr.length > 1) {
      newArr.sort(this.compare('key'))
    }
    const otherArr = []
    for (let i = 0; i < newArr.length; i++) {
      if (i === 0) {
        otherArr.push({ key: newArr[0].key, data: [newArr[0].data] })
      } else {
        if (newArr[i].key === newArr[i - 1].key) {
          otherArr[i - 1]?.data.push(newArr[i].data)
        } else {
          otherArr.push({ key: newArr[i].key, data: [newArr[i].data] })
        }
      }
    }
    return otherArr
  }

  compare = (key: string) => {
    return function (obj1: any, obj2: any) {
      const val1 = obj1[key]?.toLowerCase();
      const val2 = obj2[key]?.toLowerCase();
      if (val1 < val2) {
        return -1
      } else if (val1 > val2) {
        return 1
      } else {
        return 0
      }
    }
  }

  dropdownTabsContent = (val: any) => {
    if (!val) return
    const { fieldNames } = this.props
    const valueKey = fieldNames?.value || 'value'
    const labelKey = fieldNames?.label || 'label'
    // const newArr = []
    // val.forEach((item: any) => {
    //   newArr.push(item[valueKey]?.slice(0, 1))
    // })
    const newList = this.getTopLink(val)
    const topData = []
    newList.forEach(item => {
      topData.push(item.key)
    })
    // let newList1 = Array.from(new Set(topData))
    const dropdownTabsContentTop = (
      <div className="ac-group-cascader-top">
        {newList.map((item, index) => {
          return <div key={item.key} className={`ac-group-cascader-top-link ${this.state.linkKey === '' ? index === 0 ? 'ac-group-cascader-top-link-active' : '' : item.key === this.state.linkKey ? 'ac-group-cascader-top-link-active' : ''}`} style={{ display: 'inline-block', width: '66px', height: '40px', lineHeight: '40px', textAlign: 'center' }} onClick={this.onChangeWz.bind(this, item)}><div>{item.key}</div></div>
        })}
      </div>
    )
    val.sort(this.compare('groupContentKey'))
    const creatData = this.getContentData(val)

    let dropdownTabsContentBody = null
    if (val[0]?.isGroupNum === 0 || val?.length > val[0]?.isGroupNum) {
      dropdownTabsContentBody = (
        <>
          {
            creatData?.map(item => {
              return <div key={item.groupContentKey} id={item.data[0][valueKey]} className="ac-group-cascader-content">
                <div className="ac-group-cascader-content-left">{item.groupContentKey}</div>
                <div className="ac-group-cascader-content-right">
                  {
                    item.data.map((contentItem: any) => {
                      return <div className='ac-group-cascader-content-right-item' style={{ width: `${contentItem[labelKey]?.length > 5 ? '172px' : '86px'}` }} key={contentItem[valueKey]} onClick={this.onChangeValue.bind(this, contentItem)} title={contentItem[labelKey]}>{contentItem[labelKey]}</div>
                    })
                  }
                </div>
              </div>
            })
          }
        </>
      )
    } else {
      dropdownTabsContentBody = (
        <>
          {
            val?.map((item: any) => {
              return <div key={item[labelKey]} className='ac-group-cascader-content-item' onClick={this.onChangeValue.bind(this, item)} title={item[labelKey]} style={{ width: `${item[labelKey]?.length > 5 ? '172px' : '86px'}` }}>{item[labelKey]}</div>
              // return <div key={item.groupContentKey} className="ac-group-cascader-content">
              //   <div className="ac-group-cascader-content-left">{item.groupContentKey}</div>
              //   <div className="ac-group-cascader-content-right">
              //     {
              //       item.data.map((contentItem: any) => {
              //         return <div className='ac-group-cascader-content-right-item' style={{ width: `${contentItem[labelKey]?.length > 5 ? '172px' : '86px'}` }} key={contentItem[valueKey]} onClick={this.onChangeValue.bind(this, contentItem)} title={contentItem[labelKey]}>{contentItem[labelKey]}</div>
              //       })
              //     }
              //   </div>
              //   <div className='ac-group-cascader-content-right-item' onClick={this.onChangeValue.bind(this, item)} title={item[labelKey]}>{item[labelKey]}</div>
              // </div>
            })
          }
        </>
      )
    }
    const pushDom = (val[0]?.isGroupNum === 0 || val?.length > val[0]?.isGroupNum) ? { dropdownTabsContentTop, dropdownTabsContentBody } : { dropdownTabsContentTop: null, dropdownTabsContentBody }
    return pushDom
    // return { dropdownTabsContentTop, dropdownTabsContentBody }
  }

  onSearch = (val: string[], val2: any) => {
    this.props?.onSearch(val, val2)
    // let {searchValue} = this.state
    this.setState({
      inputValue: val
    })
    // this.setState({
    //   dropdownRender:
    // })
    // if (val == '') {
    //   console.log('不能清空吗', val)
    //   this.setState({
    //     dropdownRender: null
    //   })
    // }
  }

  render () {
    const { loadDataFlag, searchValue, showSearch, ...others } = this.props
    return (
      <div className='ac-group-cascader'>
        <Cascader
          {...others}
          dropdownType={this.state.dropdownRender && loadDataFlag && showSearch ? '' : 'tiled'}
          dropdownTabsContent = {this.dropdownTabsContent}
          onChangeTabs = {this.onChangeTabs}
          popupClassName='ac-group-cascader-dropdown'
          // eslint-disable-next-line no-return-assign
          onRef={(node: any) => this.cascader1 = node}
          onSearch={this.onSearch}
          showSearch={showSearch}
          dropdownRender={loadDataFlag ? this.state.dropdownRender : null}
          // inputValue={this.state.inputValue}
          // searchValue={this.state.searchValue}
          loadDataFlag={loadDataFlag}
          // options={this.state.options}
        ></Cascader>
      </div>
    )
  }
}
export default GroupCascader